var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Call_Waiting"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call_Waiting",
    "data-name": "Call Waiting",
    clipPath: "url(#clip-Call_Waiting)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "waiting",
    transform: "translate(-0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M325.825,1.669A1.669,1.669,0,0,1,327.494,0c.586,0,1.179.017,1.765.05a1.669,1.669,0,0,1-.094,3.336s-.843-.048-1.671-.048a1.669,1.669,0,0,1-1.669-1.669Z",
    transform: "translate(-257.837 0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M371.533,8.858a1.667,1.667,0,0,1,2.128-1.02,29.749,29.749,0,0,1,3.132,1.3,1.669,1.669,0,0,1-.728,3.171c-.743,0-.852-.388-3.511-1.327A1.667,1.667,0,0,1,371.533,8.858Z",
    transform: "translate(-293.933 -6.127)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M279.325,101.123V97.716A11.454,11.454,0,0,1,283.5,88.9a11.448,11.448,0,0,1-4.179-8.815V76.675A4.68,4.68,0,0,1,284,72h13.6a4.68,4.68,0,0,1,4.675,4.675v3.407A11.457,11.457,0,0,1,298.1,88.9a11.457,11.457,0,0,1,4.177,8.817v3.407A4.68,4.68,0,0,1,297.6,105.8H284A4.68,4.68,0,0,1,279.325,101.123Z",
    transform: "translate(-221.038 -56.978)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M417.89,35.546a1.668,1.668,0,0,1,2.358-.131,30.983,30.983,0,0,1,2.4,2.4,1.669,1.669,0,1,1-2.489,2.224,27.521,27.521,0,0,0-2.136-2.136A1.665,1.665,0,0,1,417.89,35.546Z",
    transform: "translate(-330.357 -27.689)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M218.681,69.769a30.357,30.357,0,0,1-18.2-54.653l-1.254-.415a1.67,1.67,0,0,1,1.047-3.171l4.506,1.49a1.678,1.678,0,0,1,1.04,1.01c.166.453.131.2-.216,5.42a1.669,1.669,0,0,1-3.334-.111c0-.073-.007.061.094-1.463A27.018,27.018,0,1,0,245.653,37.84a1.67,1.67,0,1,1,3.334-.192A30.389,30.389,0,0,1,218.681,69.769Z",
    transform: "translate(-149.024 -9.057)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M449.843,80.1a1.669,1.669,0,1,1,3-1.454,30.471,30.471,0,0,1,1.306,3.136A1.669,1.669,0,1,1,451,82.886,26.614,26.614,0,0,0,449.843,80.1Z",
    transform: "translate(-355.849 -61.49)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M62.046,153.256a1.032,1.032,0,0,1-1.6-.173,62.527,62.527,0,0,0-18.791-18.768,1.034,1.034,0,0,1-.142-1.633,8.06,8.06,0,0,1,9.56-1.321,33.1,33.1,0,0,1,12.305,12.3A7.943,7.943,0,0,1,62.046,153.256Z",
    transform: "translate(-32.578 -103.155)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M65.646,222.692c-30.67,20.819-81.585-30.137-60.775-60.8a1.672,1.672,0,0,1,2.279-.464c8.664,5.5,13.345,11.2,18.429,18.744a1.678,1.678,0,0,1,.126,1.648c-4.468,9.594,10.483,24.5,20.049,20.015a1.668,1.668,0,0,1,1.585.088,58.942,58.942,0,0,1,18.779,18.5A1.667,1.667,0,0,1,65.646,222.692Z",
    transform: "translate(0 -127.544)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M258.56,349.675a1.034,1.034,0,0,1-1.643-.133,62.3,62.3,0,0,0-18.765-18.79,1.03,1.03,0,0,1-.161-1.612,7.985,7.985,0,0,1,9.591-1.329,33.117,33.117,0,0,1,12.3,12.305A8.055,8.055,0,0,1,258.56,349.675Z",
    transform: "translate(-188.077 -258.601)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWaiting);
export default __webpack_public_path__ + "static/media/call_waiting.aab7207b26adf41b78cb2945491fc276.svg";
export { ForwardRef as ReactComponent };